import Vue from 'vue'
import App from './App'
import router from './router' 
import { Toast, Button, Loading } from 'vant';

import 'vant/lib/index.css';
Vue.config.productionTip = false

Vue.use(Toast);
Vue.use(Button);
Vue.use(Loading);

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
  // 聚焦元素
      el.focus()
    }
  })
  


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router, 
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js